<div class="box-wrapper">
  <app-caption [text]="header"></app-caption>
  <div class="label">
    <a *ngIf="link; else noLink" class="label-link" [href]="link" (click)="$event.preventDefault()">{{ label }}</a>
    <ng-template #noLink>
      {{ (label | translate) || '---' }}
    </ng-template>
  </div>
</div>
